import { render, staticRenderFns } from "./PackageItemDetail.vue?vue&type=template&id=4cfb12cd&scoped=true&"
import script from "./PackageItemDetail.vue?vue&type=script&lang=js&"
export * from "./PackageItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb12cd",
  null
  
)

export default component.exports